import { useEffect, useState } from "react";
import OtpPromptModal from "./OtpPromptModal";
import {
  subscribeOtpPrompt,
  OtpPromptCancelledError,
  type OtpPromptHandle,
} from "@/lib/otp-prompt";

/**
 * 挂载在 App 根上，订阅 OTP 请求并展示 modal。
 * 同一时刻只展示一个 modal；新请求到达时排队（FIFO）。
 */
export default function OtpPromptHost() {
  const [queue, setQueue] = useState<OtpPromptHandle[]>([]);

  useEffect(() => {
    const unsubscribe = subscribeOtpPrompt((handle) => {
      setQueue((prev) => [...prev, handle]);
    });
    return unsubscribe;
  }, []);

  const current = queue[0];

  const handleConfirm = (code: string) => {
    if (!current) return;
    current.resolve(code);
    setQueue((prev) => prev.slice(1));
  };

  const handleCancel = () => {
    if (!current) return;
    current.reject(new OtpPromptCancelledError());
    setQueue((prev) => prev.slice(1));
  };

  return (
    <OtpPromptModal
      open={!!current}
      title={current?.request.title}
      description={current?.request.description}
      endpoint={current?.request.endpoint}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
}
